import { Box, Divider, Flex, Text } from "@chakra-ui/react";
import React from "react";
import DynamicTable from "../../DynamicTable/DynamicTable";

export const Health = ({ healthData, carbonData, siliconData }) => {
  console.log(healthData);
  //   const filteredData = inputData.filter((item) => item.Value !== 0);
  return (
    <Flex
      m="auto"
      mt="0"
      mb="0"
      w="100%"
      justify="space-between"
      direction="column"
    >
      {/* <Flex gap="2rem" justify="space-between" mb="1rem">
        {maximum_numberof_charges !== undefined &&
          maximum_charges_caused_by !== undefined && (
            <>
              <Code
                colorScheme="green"
                children={`Maximum number of charges with the burden : ${maximum_numberof_charges}`}
                p="5px"
                fontSize="15px"
              />
              <Code
                colorScheme="green"
                children={`Minimum chargeable Lot no. : ${maximum_charges_caused_by["Lot no."]} (${maximum_charges_caused_by["Type"]})`}
                p="5px"
                fontSize="15px"
              />
            </>
          )}
        {resistance_set_points?.length > 0 && (
          <>
            <Code
              colorScheme="red"
              // children={`Resistance set point : R1 = ${resistance_set_points[0]}`}
              children={`Resistance set point : R1 = 1.6`}
              // children={resistance_set_points.map((el, idx) => {
              //   return idx === resistance_set_points.length - 1
              //     ? `R${idx + 1} = ${el}`
              //     : `R${idx + 1} = ${el} , `;
              // })}
              p="5px"
              fontSize="15px"
            />
          </>
        )}
      </Flex> */}
      <Flex w="100%" className="items-start gap-5">
        <Box className="w-full">
          <Flex justify="left" gap="10px" w="100%" direction="column">
            <Text fontWeight="500">HEALTH</Text>
            <Divider border="2px solid #1a174e" w="50%" />
          </Flex>
          <DynamicTable
            height={"70vh"}
            data={healthData || []}
            headers={["Metric", "Current", "Expected", "Deviation"]}
          />
        </Box>
        <Box className="w-full">
          <Flex justify="left" gap="10px" w="100%" direction="column">
            <Text fontWeight="500">CARBON CONTROL</Text>
            <Divider border="2px solid #1a174e" w="50%" />
          </Flex>
          <DynamicTable
            height={"70vh"}
            data={carbonData || []}
            showHeaders={false}
          />
        </Box>
        <Box className="w-full">
          <Flex justify="left" gap="10px" w="100%" direction="column">
            <Text fontWeight="500">SILICON CONTROL</Text>
            <Divider border="2px solid #1a174e" w="50%" />
          </Flex>
          <DynamicTable
            height={"70vh"}
            data={siliconData || []}
            showHeaders={false}
          />
        </Box>
        {/* <Box w="49%">
          <Flex justify="space-between" w="100%" align="center">
            <Flex justify="left" gap="10px" w="50%" direction="column">
              <Text fontWeight="500">INDIVIDUAL OUTPUT</Text>
              <Divider border="2px solid #1a174e" w="100%" />
            </Flex>
          </Flex>
          <DynamicTable height={"50vh"} data={outputData || []} />
        </Box> */}
      </Flex>
    </Flex>
  );
};
